import { render } from "./MobileBlogPost.vue?vue&type=template&id=c4362aae&scoped=true"
import script from "./MobileBlogPost.vue?vue&type=script&lang=js"
export * from "./MobileBlogPost.vue?vue&type=script&lang=js"

import "./MobileBlogPost.vue?vue&type=style&index=0&id=c4362aae&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4362aae"]])

export default __exports__